import { resetNavbar } from '../fabric-toolbar/reset-navbar.js';

export type FabricWebviewLocationToOptions = {
  /**
   * 让指定网页地址在当前webview容器跳转, 并指定是否产生浏览器栈, 默认产生 replace: false
   */
  url: string;
  /**
   * 是否提供当前浏览器的栈, 类似location.replace的能力.
   * @default false
   */
  replace?: boolean;
};

export type FabricWebviewLocationToApi = (
  options: FabricWebviewLocationToOptions
) => void;

/**
 * 保留当前webview窗口，刷新打开下一个指定的网页, 并且无论打开之前是否设置过navbar都自动强制重置navbar的所有配置(自动重新获取新的URL地址的document.title)
 * 并且让默认的back按钮支持栈会回退, 再到webview退出, 如果新页面自定义配置了navbar, 新Navbar行为能力与 `setNavbar`配置能力为准.
 */
export const locationTo: FabricWebviewLocationToApi = (
  options: FabricWebviewLocationToOptions
) => {
  // 1. 重置标题栏, 让native走自动的标题栏能力,自动识别打开URL地址的document.title
  resetNavbar();
  // 2. 调原生的location.href, location.replace();
  if (options.replace) {
    location.replace(options.url);
  } else {
    location.href = options.url;
  }
};
